<app-pricing [demo]="true"></app-pricing>
